module.exports = __webpack_public_path__ + "img/express-blanc.b8d2132b.png";